<template>
    <div class="add_adminAdd_mask"  v-if="addOk">
    <el-card class="newAdd_adminAdd">
        <div slot="header" class="clearfix" style="text-align:center;">
            <span style="line-height: 36px;">新增版本号</span>
        </div>
        <div class="resourseContent">
            <p>
                <span class="col-lg-3">版本</span><el-input class="col-lg-4" v-model="version"></el-input>
            </p>
            <p>
                <span class="col-lg-3">版本号</span><el-input class="col-lg-4" v-model="versionCode"></el-input>
            </p>
            <p>
                <span class="col-lg-3">更新范围</span><el-select class="col-lg-4" v-model="updeteArea" placeholder="">
                    <el-option v-for="items in areaList" :value="items.value"  :label="items.label" :key="items.value"></el-option>
                </el-select>
            </p>
             <p>
                <span class="col-lg-3">设备类型</span><el-input class="col-lg-4" v-model="deviceType"></el-input>
            </p>
             <p>
                <span class="col-lg-3">版本描述</span><el-input class="col-lg-4" v-model="versionDesc"></el-input>
            </p>
            <p>
                <span class="col-lg-3">上传文件</span>
                <el-upload
                    ref="upload"
                    class="col-lg-4"
                    action="http://upload.qiniu.com/"
                    :data="myForm"
                    method="post"
                    :on-preview="handlePreview"
                    name="file"
                    :on-remove="handleRemove"
                    :before-upload="handleBeforeUpload"
                    :on-success="handleSuccess"
                    :multiple="isMultiple"
                    :file-list="fileList">
                    <el-button size="small" type="primary">选择文件</el-button>
                </el-upload>
            </p>
            <p>
                <span class="col-lg-3">版本路径</span><span class="col-lg-4" style="color: green">{{versionUrl}}</span>
            </p>
            <p style="text-align:center;"><el-button type="success" @click="commit" style="width: 240px;">确定</el-button></p>
        </div>
        <span @click="boxColose" style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949"><i class="el-icon-close Danger"></i></span>
    </el-card>
    </div>
</template>
<script>
    import $ajax from '../../https/config'
    export default {
      props: ['addShow'],
      data () {
        return {
          version: '',
          versionCode: '',
          updeteArea: 0,
          deviceType: '',
          versionDesc: '',
          versionUrl: '',
          areaList: [{
            label: '全局',
            value: 0
          }, {
            label: '区域',
            value: 1
          }, {
            label: '服务APP',
            value: 2
          }],
          loading: false,
          fileList: [],
          fileNum: 0,
          form: {},
          isMultiple: true,
          token: ''
        }
      },
      computed: {
        addOk: function () {
          return this.addShow
        },
        myForm: {
          set: function (value) {
            this.form = value
          },
          get: function () {
            return this.form
          }
        }
      },
      created: function () {
        this.getUpToken()
      },
      methods: {
        boxColose () {
          this.fileNum = 0
          this.version = ''
          this.versionCode = ''
          this.updeteArea = 0
          this.deviceType = ''
          this.versionDesc = ''
          this.versionUrl = ''
          this.$emit('closeAddAccount', false)
        },
        getUpToken () {
          var myUrl = 'http://platform.songzb.com:32000/qiniuToken/version'
          var _this = this
          $ajax.get(myUrl, '', '', function (res) {
            _this.form.token = res.uptoken
          }, function () {
          })
        },
        handlePreview (file) {
        },
        handleRemove (file, fileList) {
          this.fileNum = 0
          this.versionUrl = ''
        },
        handleBeforeUpload (file) {
          var last
          last = file.name.split('.').pop()
          if (this.fileNum === 1) {
            this.$message({
              type: 'error',
              message: '一次只能上传一张图片'
            })
            return Promise
          }
          if (last !== 'apk') {
            this.$message({
              type: 'error',
              message: '文件格式错误'
            })
            return false
          }
          if (file.size / (1024 * 1024) > 30) {
            this.$message({
              type: 'error',
              message: '图片大小超过30mb'
            })
            return false
          }
          this.fileNum = 1
          var str = 'zds-apk-' + (new Date().getTime()) + Math.ceil(Math.random() * 10) + '.' + last
          this.form.key = str
        },
        handleSuccess (response, file, fileList) {
          this.versionUrl = 'http://version.songzb.com/' + response.key
        },
        commit () {
          var that = this
          var params = {
            versionName: that.version,
            versionCode: that.versionCode,
            area: that.updeteArea,
            deviceModel: that.deviceType,
            description: that.versionDesc,
            zippath: that.versionUrl
          }
          if (that.version.trim() === '') {
            that.$message({
              type: 'error',
              message: '版本不能为空'
            })
            return
          }
          if (that.versionCode.trim() === '') {
            that.$message({
              type: 'error',
              message: '版本号不能为空'
            })
            return
          }
          if (that.deviceType.trim() === '') {
            that.$message({
              type: 'error',
              message: '设备类型不能为空'
            })
            return
          }
          if (that.versionDesc.trim() === '') {
            that.$message({
              type: 'error',
              message: '版本描述不能为空'
            })
            return
          }
          if (that.fileNum === 0) {
            that.$message({
              type: 'error',
              message: '请选择要上传的资源！'
            })
            return
          }
          $ajax.post('/manager/addVersion', params, 'headers', function (res) {
            if (res.resultStatus === true) {
              that.$message({
                type: 'success',
                message: '新增版本信息成功'
              })
              that.boxColose()
            }
          }, function () {
          })
        }
      }
    }
</script>
<style lang="scss">
  .add_adminAdd_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 100;
      text-align: center;
  
      .newAdd_adminAdd {
        min-height: 530px;
        width: 500px;
        top: 20%;
        left: 45%;
        z-index: 101;
        margin-left: -200px;
        position: fixed;

        .el-card__header {
            padding: 10px
        }
        .el-tabs__header {
            margin-bottom: 0;
        }
        .resourseContent {
            text-align: left;
        }
        .col-lg-3 {
            width: 20%;
            display: inline-block;
            font-weight: 700;
            color: #777;
            vertical-align: top;
        }
        .col-lg-4 {
            width: 72%;
            display: inline-block;

            textarea {
              height: 120px;
            }
        }

      }
  }
</style> 


// WEBPACK FOOTER //
// src/page/versionMgr/popAdminNewAdd.vue